import { render } from "./CarouselSwiper.vue?vue&type=template&id=6d88d2d0"
import script from "./CarouselSwiper.vue?vue&type=script&lang=js"
export * from "./CarouselSwiper.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__